
import { User } from "domain/entities/user";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface UserState {
  user: User | null;
  setUser: (newUser: Partial<User>) => void;
  resetUser: () => void;
}

const initialUserState: User = {
  id: "",
  email: "",
  profileType: "",
  profileId: "",
  roles: [],
  createdAt: new Date(),
  modifiedAt: new Date(),
};

export const useUserStore = create<UserState>()(
  devtools(
    (set) => ({
      user: initialUserState,
      setUser: (newUser) =>
        set((state) => ({
          user: { ...state.user, ...newUser } as User,
        })),
      resetUser: () => set({ user: initialUserState }),
    }),
    { name: "UserSelected" }
  )
);
